import React from 'react';
import {Provider} from "components/account-register/RegisterContext";
import {RegisterList} from "components/account-register/RegisterList";

export const Registers = () => {

    return (
        <Provider>
            <RegisterList/>
        </Provider>
    );
}
